import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, EditableDBItemV3, EditableItem, getElementCenterPos, Grid, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, ModuleFE_Toaster, mouseInteractivity_PopUp, openContent, SimpleListAdapter, TS_DropDown, TS_Input, TS_PropRenderer, TS_Radio, TS_Toggle } from '@nu-art/thunderstorm-frontend/index';
import { _keys, asArray, BadImplementationException, cloneObj, exists, Filter, MUSTNeverHappenException, sortArray, voidFunction } from '@nu-art/ts-common';
import { DBDef_OrderConfiguration, EHR_OrderConfigAvailabilities, Order_AvailabilityLabelMap, Order_DaysLabelMap, Order_DaysOrder, OrderAvailability_Always, OrderAvailability_Partial, OrderConfig_ApplyIdAffix_Default, IdAffixFamilyByResourceType, } from '@app/org-shared';
import { DropDown_Variable, ModuleFE_Resource, QScrollWrapper } from '@app/hcs-frontend';
import './Editor_Organization_InstallationOrders.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { EHROrderTimeInput } from './Renderer_EHROrderTime.js';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { Dialog_Confirmation, ICONS } from '@app/styles';
import { DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import { DropDown_Action, ModuleFE_Action } from '@app/pathway-frontend';
import { Component_TagGroups } from '@app/hcs-frontend/tag';
import { Dialog_CopyOrders } from './CopyOrdersDialog/Dialog_CopyOrders.js';
import { ModuleFE_OrderConfiguration } from '../../../../../_entity/installation/order-configuration/index.js';
import { ModuleFE_Organization } from '../../../../../_entity/organization/index.js';
const ViewKey_Edit = 'edit';
const ViewKey_View = 'view';
const missingKeysLabelMap = {
    ehrInstallationId: 'EHR Installation ID',
    availability: 'Availability',
    orderId: 'Order',
    ehrInstallationOrderId: 'Installation Order ID',
    applyIdAffix: 'Apply id suffix',
};
export class Editor_Organization_InstallationOrders extends ComponentSync {
    __onActionUpdated(...params) {
        this.forceUpdate();
    }
    ;
    __onOrderConfigurationUpdated(...params) {
        // If sync update the selected item
        if ((params[0] === 'update' || params[0] === 'upsert-all')
            && (asArray(params[1])[0]?._id === this.state.editable?.get('_id'))) {
            return this.state.editable?.updateItem(asArray(params[1])[0]);
        }
        this.forceUpdate();
    }
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editMode = nextProps.editMode;
        state.organizationId = nextProps.organizationId;
        state.ehrInstallationId = nextProps.ehrInstallationId;
        state.newOrderLabel ??= undefined;
        state.newVariableType ??= undefined;
        state.selectedVariableId ??= undefined;
        state.shouldCreateOrder ??= false;
        //Looking at new / different installation
        if (this.state?.ehrInstallationId !== state.ehrInstallationId) {
            const orderConfigs = ModuleFE_OrderConfiguration.cache.filter(oc => oc.ehrInstallationId === state.ehrInstallationId);
            if (orderConfigs.length)
                state.editable = this.getEditableOrderConfig(orderConfigs[0]);
            else
                state.editable = undefined;
        }
        return state;
    }
    // ######################## Logic ########################
    // order config logic
    createNewOrderConfig = () => {
        const currentEditable = this.state.editable;
        //If currently editing a new order config
        if (currentEditable && !currentEditable.item._id)
            return;
        this.setState({
            editable: this.getEditableOrderConfig({
                ehrInstallationId: this.state.ehrInstallationId,
                availability: { type: OrderAvailability_Always },
                applyIdAffix: OrderConfig_ApplyIdAffix_Default,
            })
        });
    };
    getEditableOrderConfig(_dbItem) {
        if (!_dbItem.ehrInstallationId)
            _dbItem.ehrInstallationId = this.state.ehrInstallationId;
        return new EditableDBItemV3(_dbItem, ModuleFE_OrderConfiguration)
            .setOnChanged(async () => this.forceUpdate())
            .setAutoSave(!!_dbItem._id)
            .setDebounceTimeout(100);
    }
    selectOrderConfig = (orderConfig) => {
        if (!orderConfig._id)
            return;
        this.setState({
            editable: this.getEditableOrderConfig(orderConfig),
        });
    };
    getViewKey = () => this.state.editMode ? ViewKey_Edit : ViewKey_View;
    // order time logic
    onOrderTimeSaved = async (item, index, day) => {
        const editable = this.state.editable;
        if (editable?.item.availability?.type !== OrderAvailability_Partial)
            throw new BadImplementationException('Saving an order time when availability is no partial!');
        if (index === -1) {
            if (!editable.item.availability.data[day])
                editable.item.availability.data[day] = [];
            editable.item.availability.data[day].push(item);
        }
        else {
            editable.item.availability.data[day][index] = item;
        }
        await editable.save(true);
        this.forceUpdate();
    };
    getOrderTimeEditable = (config, index, day) => {
        return new EditableItem(config).setSaveAction(async (item) => {
            await this.onOrderTimeSaved(item, index, day);
            return item;
        }).setAutoSave(true);
    };
    onOrderRightClick = (e, order) => {
        if (!order._id)
            return;
        const actions = this.getOrderActions(order);
        if (!actions.length)
            return;
        ModuleFE_MouseInteractivity.showContent({
            id: 'order-pop-up-menu',
            originPos: getElementCenterPos(e.currentTarget),
            modalPos: { x: 1, y: 1 },
            content: () => _jsx(_Fragment, { children: actions.map(action => {
                    return _jsx("div", { className: 'popup-action', onClick: action.action, children: action.label }, action.label);
                }) })
        });
    };
    getOrderActions = (order) => {
        const orderLabel = ModuleFE_Action.cache.unique(order.orderId)?.name;
        const actions = [];
        if (ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Organization.permissions.collection.edit) === AccessLevel.HasAccess) {
            actions.push({
                label: 'Delete Order',
                action: () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    Dialog_Confirmation.show({
                        header: `Delete EHR Installation Order`,
                        content: () => _jsxs(_Fragment, { children: ["Are you sure you want to delete ", orderLabel, "?"] }),
                        buttons: [
                            {
                                label: 'Yes, Delete', isAsync: true, action: async () => {
                                    await ModuleFE_OrderConfiguration.v1.delete(order).executeSync();
                                    if (this.state.editable?.item._id === order._id)
                                        return this.setState({ editable: undefined });
                                    this.forceUpdate();
                                }
                            },
                            { label: 'Don\'t Delete', isPreferred: true, action: voidFunction }
                        ]
                    });
                }
            });
        }
        return actions;
    };
    orderIsIncomplete = (order) => {
        const keys = _keys(DBDef_OrderConfiguration.modifiablePropsValidator);
        return keys.filter(key => {
            if (key === 'applyIdAffix')
                return false;
            return !order[key];
        });
    };
    createNewOrder = async (orderToCreate, selectedVariableId, variableType) => {
        const editable = this.state.editable;
        if (!editable)
            return;
        const installationOrder = cloneObj(editable.item);
        const order = (await (ModuleFE_Action._v1.createOrderWithVariable({
            orderLabel: orderToCreate,
            variableId: selectedVariableId,
            variableType
        })).executeSync()).order;
        installationOrder.orderId = order._id;
        editable.updateItem(installationOrder);
    };
    onClickSave = async () => {
        const { newOrderLabel, editable, selectedVariableId, newVariableType } = this.state;
        try {
            if (newOrderLabel)
                await this.createNewOrder(newOrderLabel, selectedVariableId, newVariableType);
            await editable?.save();
            this.setState({
                shouldCreateOrder: false,
                selectedVariableId: undefined,
                newVariableType: undefined,
                newOrderLabel: undefined
            });
            this.forceUpdate();
        }
        catch (err) {
            ModuleFE_Toaster.toastError(`Could not save order`);
            this.logError(err);
            this.forceUpdate();
        }
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_H_C, { className: 'editor-organization-installation-orders', children: [this.renderOrdersList(), this.renderForm()] });
    }
    // ######################## Render - Order List ########################
    renderOrdersList = () => {
        return _jsxs(LL_V_L, { className: 'editor-organization-installation-orders__orders', children: [this.renderListButtons(), this.render_OrderSearch(), this.renderOrders()] });
    };
    renderListButtons = () => {
        if (!this.state.editMode)
            return _jsx(_Fragment, {});
        return _jsxs(LL_V_L, { className: 'editor-organization-installation-orders__orders__buttons', children: [_jsx(Button, { variant: 'primary', onClick: this.createNewOrderConfig, children: "Add Another Order" }), _jsx(Button, { variant: 'tertiary', onClick: this.copyOrdersDialog, children: "Copy Orders" })] });
    };
    copyOrdersDialog = () => {
        Dialog_CopyOrders.show({ targetEHRInstallationId: this.state.ehrInstallationId });
    };
    render_OrderSearch = () => {
        return _jsxs(LL_H_C, { className: 'order-search', children: [_jsx(TS_Input, { type: 'text', value: this.state.orderSearchTerm, onChange: val => this.setState({ orderSearchTerm: val }) }), _jsx(ICONS.search.component, {})] });
    };
    renderOrders = () => {
        const filter = this.state.orderSearchTerm?.length ? new Filter(config => {
            const order = ModuleFE_Action.cache.unique(config.orderId);
            return [order?.name ?? 'N/A'];
        }).prepareFilter(this.state.orderSearchTerm) : undefined;
        let orderConfigs = ModuleFE_OrderConfiguration.cache.filter(oc => {
            if (oc.ehrInstallationId !== this.state.ehrInstallationId)
                return false;
            return !filter || filter.filterImpl(oc);
        });
        orderConfigs = sortArray(orderConfigs, config => {
            const order = ModuleFE_Action.cache.unique(config.orderId);
            return order?.name.toLowerCase() ?? '_new';
        });
        return _jsxs(QScrollWrapper, { children: [this.renderSelectedOrder(), orderConfigs.map(this.renderOrder)] });
    };
    renderSelectedOrder = () => {
        const editable = this.state.editable;
        if (!editable || editable.item._id)
            return;
        return this.renderOrder(editable.item);
    };
    renderOrder = (orderConfig) => {
        const editable = this.state.editable;
        const order = ModuleFE_Action.cache.unique(orderConfig.orderId);
        const missingKeys = this.orderIsIncomplete(orderConfig);
        const className = _className('editor-organization-installation-orders__order', editable?.item._id === orderConfig._id && 'selected');
        return _jsxs("div", { className: className, onClick: () => this.selectOrderConfig(orderConfig), onContextMenu: e => this.onOrderRightClick(e, orderConfig), children: [!!missingKeys.length && _jsx(ICONS.missingInfo.component, { className: 'editor-organization-installation-orders__order__incomplete', ...openContent.tooltip.top('editor-organization-installation-orders__order__incomplete-tooltip', () => this.renderMissingKeysTooltipContent(missingKeys), { offset: -5 }) }), order?.name ?? 'New'] }, orderConfig._id ?? 'new-config');
    };
    renderMissingKeysTooltipContent = (missingKeys) => {
        return _jsxs(_Fragment, { children: ["Instance Order is missing the following data:", _jsx("br", {}), missingKeys.map(key => missingKeysLabelMap[key]).join(', ')] });
    };
    // ######################## Render - Order Editor ########################
    renderForm = () => {
        if (!this.state.editable)
            return _jsx(_Fragment, {});
        const className = _className(this.state.editMode && 'edit-mode');
        return _jsxs(Grid, { className: className, children: [this.renderSaveButton(), this.renderDBOrder(), this.renderVariable(), this.renderOrderTags(), this.renderEHRInstallationOrderId(), this.renderApplyIdAffix(), this.renderAvailabilityDropdown(), this.renderPartialAvailabilityTimes()] });
    };
    renderEditOrder = () => {
        const editable = this.state.editable;
        const newOrderName = this.state.newOrderLabel;
        if (newOrderName && !editable?.item._id)
            return _jsx("div", { className: 'grid-data', children: newOrderName });
        return (_jsx(DropDown_Action.editable, { editable: editable, prop: 'orderId', queryFilter: ModuleFE_Action.is.order, noOptionsRenderer: (input) => editable?.item._id ? 'No Options Found' : _jsxs("div", { onClick: () => this.setState({ newOrderLabel: input, shouldCreateOrder: true }), children: ["+ Create a new order - ", input] }) }));
    };
    renderDBOrder = () => {
        const editable = this.state.editable;
        const internalId = editable?.item._id ?? '-';
        const order = ModuleFE_Action.cache.unique(editable?.item.orderId);
        const orderName = order?.name ?? '-';
        return _jsxs(_Fragment, { children: [_jsx(TS_PropRenderer.Flat, { label: 'Order', error: editable?.hasError('orderId'), children: _jsx(Component_SwitchView, { mode: this.getViewKey(), modes: [
                            {
                                key: ViewKey_View,
                                renderer: () => _jsx("div", { className: 'grid-data', onClick: () => ModuleFE_Thunderstorm.copyToClipboard(orderName), children: orderName })
                            },
                            {
                                key: ViewKey_Edit,
                                renderer: this.renderEditOrder
                            }
                        ] }) }), _jsx(TS_PropRenderer.Flat, { label: 'Internal ID', children: _jsx("div", { onClick: () => ModuleFE_Thunderstorm.copyToClipboard(internalId), className: 'grid-data', children: internalId }) })] });
    };
    renderVariableCreation = () => {
        const { newVariableType, newOrderLabel } = this.state;
        return _jsxs(LL_V_L, { className: 'variable-container__new-variable', children: ["Create a new variable - ", newOrderLabel, " with type:", _jsx(TS_Radio, { values: ['YesNo', 'PosNeg'], groupName: 'types', className: 'label-radio', checked: newVariableType, onCheck: value => this.setState({ newVariableType: value }) }), _jsx("div", { onClick: () => this.setState({ newVariableType: undefined }), className: 'variable-container__new-variable__select', children: "Select an existing variable" })] });
    };
    renderVariableSelection = () => {
        const orderName = this.state.newOrderLabel;
        return _jsxs(LL_V_L, { children: [_jsx(DropDown_Variable, { selected: this.state.selectedVariableId, onSelected: selectedVar => {
                        this.setState({ selectedVariableId: selectedVar._id });
                    } }), _jsxs(LL_H_C, { onClick: () => this.setState({ newVariableType: 'YesNo', selectedVariableId: undefined }), className: 'variable-container__select-variable', children: [_jsx(ICONS.advisor_avn_add.component, { className: 'variable-container__select-variable__add-icon' }), _jsxs("div", { className: 'variable-container__select-variable__label', children: ["Or Create a new variable - ", orderName] })] })] });
    };
    renderVariable = () => {
        const { shouldCreateOrder, newVariableType, editMode } = this.state;
        // variable selection should be visible only on creating a new order
        if (!shouldCreateOrder || !editMode)
            return;
        return _jsx(_Fragment, { children: _jsx(TS_PropRenderer.Flat, { label: 'Variable', children: _jsx("div", { className: 'variable-container', children: exists(newVariableType) ? this.renderVariableCreation() : this.renderVariableSelection() }) }) });
    };
    renderOrderTags = () => {
        const editable = this.state.editable;
        const orderId = editable?.item.orderId;
        const order = ModuleFE_Action.cache.unique(orderId);
        return _jsx(_Fragment, { children: _jsx(TS_PropRenderer.Flat, { label: 'Order Tags', children: _jsx("div", { className: 'grid-data', children: _jsx(Component_TagGroups, { tagGroups: order?.tagGroups }) }) }) });
    };
    renderEHRInstallationOrderId = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Installation Order ID', children: _jsx(Component_SwitchView, { mode: this.getViewKey(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: editable?.item.ehrInstallationOrderId ?? '-' })
                    },
                    {
                        key: ViewKey_Edit, renderer: () => _jsx(DefaultEditor_InputText_Optional, { editable: editable, prop: 'ehrInstallationOrderId' })
                    }
                ] }) });
    };
    selectedOrderUsesIdAffix = () => {
        const order = ModuleFE_Action.cache.unique(this.state.editable?.item.orderId);
        if (!ModuleFE_Action.is.order(order))
            return false;
        const resource = ModuleFE_Resource.cache.unique(order.resourceId);
        if (!resource)
            throw new MUSTNeverHappenException(`Could not get resource for id ${order.resourceId}`);
        return !!IdAffixFamilyByResourceType[resource.type];
    };
    renderApplyIdAffix = () => {
        if (!this.selectedOrderUsesIdAffix())
            return;
        const editable = this.state.editable;
        const applyIdAffix = editable?.item.applyIdAffix ?? OrderConfig_ApplyIdAffix_Default;
        return _jsx(TS_PropRenderer.Flat, { label: 'Apply id suffix', children: _jsx(Component_SwitchView, { mode: this.getViewKey(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: applyIdAffix ? 'Yes' : 'No' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_Toggle, { checked: applyIdAffix, onCheck: () => editable?.updateObj({ applyIdAffix: !applyIdAffix }) })
                    }
                ] }) });
    };
    renderAvailabilityDropdown = () => {
        const editable = this.state.editable;
        const error = editable?.hasError('availability');
        return _jsx(TS_PropRenderer.Flat, { label: 'Availability', error: typeof error === 'string' ? error : undefined, children: _jsx(Component_SwitchView, { mode: this.getViewKey(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => _jsx("div", { className: 'grid-data', children: Order_AvailabilityLabelMap[editable?.item.availability?.type] ?? '-' })
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => {
                            const adapter = SimpleListAdapter([...EHR_OrderConfigAvailabilities], item => _jsx(_Fragment, { children: Order_AvailabilityLabelMap[item.item] }));
                            return _jsx(TS_DropDown, { adapter: adapter, selected: editable?.item.availability?.type, onSelected: availability => {
                                    if (availability === editable?.item.availability?.type)
                                        return;
                                    if (availability === OrderAvailability_Always)
                                        return editable.updateObj({ availability: { type: OrderAvailability_Always } });
                                    editable.updateObj({
                                        availability: {
                                            type: OrderAvailability_Partial,
                                            data: {
                                                sun: [],
                                                mon: [],
                                                tue: [],
                                                wed: [],
                                                thu: [],
                                                fri: [],
                                                sat: [],
                                            }
                                        }
                                    });
                                } });
                        }
                    }
                ] }) });
    };
    renderPartialAvailabilityTimes = () => {
        const editable = this.state.editable;
        if (editable?.item.availability?.type !== OrderAvailability_Partial)
            return _jsx(_Fragment, {});
        const data = editable.item.availability.data;
        return _jsx(_Fragment, { children: sortArray(_keys(data), key => Order_DaysOrder.indexOf(key)).map(day => {
                if (data[day].length === 0) {
                    if (!this.state.editMode)
                        return _jsx(TS_PropRenderer.Flat, { label: `${Order_DaysLabelMap[day]}.`, className: 'indent', children: _jsx("div", { className: 'grid-data span-row', children: "-" }) }, `${day}`);
                    const time = this.getOrderTimeEditable({}, -1, day);
                    return _jsx(TS_PropRenderer.Flat, { label: `${Order_DaysLabelMap[day]}.`, className: 'indent', children: _jsx(EHROrderTimeInput, { editable: time, editMode: this.state.editMode }) }, `${day}`);
                }
                return data[day].map((timeConfig, i) => {
                    const time = this.getOrderTimeEditable(timeConfig, i, day);
                    return _jsx(TS_PropRenderer.Flat, { label: `${Order_DaysLabelMap[day]}.`, className: 'indent', children: _jsx(EHROrderTimeInput, { editable: time, editMode: this.state.editMode }) }, `${day}-${i}`);
                });
            }) });
    };
    renderSaveButton = () => {
        const editable = this.state.editable;
        if (!editable || editable?.item._id)
            return;
        return _jsxs(_Fragment, { children: [_jsx(Button, { variant: 'primary', onClick: this.onClickSave, children: "Save" }), _jsx("div", {})] });
    };
}
//# sourceMappingURL=Editor_Organization_InstallationOrders.js.map